/* Package JSON Import will be here */
import React, { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { Input, Divider, Row, Col, Button, List, Typography, Drawer, Card } from "antd";
import Img from "react-image";
import { push } from "connected-react-router";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getSearchProducts } from "reducers/searchProducts";
import { appRoutesConst } from "app/navigation";
import VoiceSearchModal from "components/filter/productSearch/VoiceSearchModal";
import { Spinner } from "components/Spinner";
import placeholderImg from "assets/img/placeholderImg.png";
import Constants from "utilities/appConstants";
import { changeProductTab } from "reducers/common";
import { clearAttrFilter } from "reducers/filter/attrFilter";
import { navigateToProductDetail } from "app/navigation";
import NoData from "components/reusable/NoData";
import { ImageLoader } from "components/Spinner";
import { GASearch, GAVoiceSearchInitiation } from "hooks/googleAnalyticsHooks";
import BarCodeSearchProducts from "components/filter/productSearch/BarCodeSearchProducts";
import { ISearchProductParams } from "models/homeModels";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Search } = Input;
const { Text } = Typography;
const { Meta } = Card;
/* Const,Let & Var will be here */

const SearchProducts = (props) => {
    const inputRef = useRef(null);

    const [searchText, setSearchText] = useState("");
    const [isShowVoiceSearchModal, setIsShowVoiceSearchModal] = useState(false);
    const [isShowSearchDrawer, setIsShowSearchDrawer] = useState(false);

    const { common, router, searchProducts, categoryMenu, appSettings, translate } = useSelector((state) => ({
        common: state.common,
        router: state.router,
        searchProducts: state.searchProducts,
        categoryMenu: state.categoryMenu,
        appSettings: state.appSettings,
        translate: getTranslate(state.locale)
    }));

    const dispatch = useDispatch();

    const checkIsFromSalesReturn = () => {
        let path = router.location.pathname;
        if ((path.includes(appRoutesConst.salesReturn)) || (path.includes(appRoutesConst.salesReturnProducts)) || (path.includes(appRoutesConst.salesReturnSummary)) || (path.includes(appRoutesConst.salesReturnHistory)) || (path.includes(appRoutesConst.salesReturnHistoryDetails)))
            return true;
        else
            return false;
    }

    const showOrHideVoiceSearch = () => {
        /* GA - track voice search initiation */
        if (!isShowVoiceSearchModal && window.isEnableGA)
            GAVoiceSearchInitiation();

        setIsShowVoiceSearchModal(!isShowVoiceSearchModal);
    }

    const onSubmitVoiceCallBack = (text) => {
        onChange(text);
    }

    /* On text change in search input */
    const onChange = (enteredText) => {
        const trimmedText = enteredText.trim();
        /* Only trigger the API if the entered text is more than 2 char */
        if (trimmedText.length > 2) {
            /* To show all product, define checkIsFromSalesReturn() as null,
              if not sales return product set as false, 
              if sales return product set as true */
            const requestObj: ISearchProductParams = {
                SearchText: trimmedText,
                NeedSalesReturn: checkIsFromSalesReturn() ? true : null,
                NeedFOC: common.isFocSelected
            };
            dispatch(getSearchProducts(requestObj));

            /* To track search text in GA */
            if (window.isEnableGA)
                GASearch(enteredText);
        }

        /* Update the actual text to the input text value */
        setSearchText(enteredText);

    };

    const clearAttrFilterAsync = async () => {
        /* Check for isEnableAttrFilter config is true */
        if (appSettings.isEnableAttrFilter) {
            /* Clear the attribute filter before navigate to one cat to another cat */
            await dispatch(clearAttrFilter(true));
        }
    }

    const onCatMenuClick = (categoryId) => {
        /* Close drawer */
        setIsShowSearchDrawer(false);

        const redirectRoute = checkIsFromSalesReturn() ? appRoutesConst.salesReturnProducts : appRoutesConst.products;
        dispatch(push(`${redirectRoute}/${Constants.CAT}_${categoryId}`));
    }

    const openProduct = async (data) => {
        /* Clear the selected tab */
        dispatch(changeProductTab(""));

        /* Clear the attribute filter before navigate to other page */
        await clearAttrFilterAsync();

        /* Close drawer */
        setIsShowSearchDrawer(false);

        const redirectRoute = checkIsFromSalesReturn() ? appRoutesConst.salesReturnProducts : appRoutesConst.products;
        if ((data.Code === "CAT")) {
            dispatch(push(`${redirectRoute}/${Constants.CAT}_${data.Id}`));
        }
        else if (data.Code === "SUCAT") {
            dispatch(push(`${redirectRoute}/${Constants.CAT}_${categoryMenu.SUCAT.data[data.Id].catId}/${Constants.SUB_CAT}_${data.Id}`));
        }
        else if (data.Code === "BR") {
            dispatch(push(`${redirectRoute}/${Constants.CAT}_${categoryMenu.BR.data[data.Id].catId}/${Constants.SUB_CAT}_${categoryMenu.BR.data[data.Id].subcatId}`));
        }
        else if (data.Code === "SKU") {
            /* Navigate the retailer to product details page */
            dispatch(navigateToProductDetail(data.Id + "/products"));
        }
    };

    const renderList = () => {
        if (searchProducts.isLoading) {
            return (<div className="mt-3">
                <Spinner message={translate("common.header.search.loading")} />
            </div>);
        }
        else {
            const renderProducts = [];
            searchProducts.ids.forEach(key => {
                const product = searchProducts.data[key];

                if (product.Code === "BR" || product.Code === "CAT" || product.Code === "SKU" || product.Code === "SUCAT")
                    renderProducts.push(product);
            });

            return (
                <List
                    itemLayout="horizontal"
                    dataSource={renderProducts}
                    renderItem={item => (
                        <List.Item onClick={(e) => openProduct(item)}>
                            <List.Item.Meta
                                avatar={
                                    <Img
                                        className="search-product-image-width border-radius-15"
                                       alt="" src={[item.ImageUrl, placeholderImg]}
                                    />
                                }
                                title={item.Name}
                                description={`(${item.LevelName})`}
                            />
                        </List.Item>
                    )}
                />
            )
        }
    };

    const showSearchDrawer = () => {
        setIsShowSearchDrawer(true);
        setTimeout(() => {
            inputRef.current.focus({ cursor: 'end' });
        }, 500);
    };

    return (
        <React.Fragment>
            <i className="fa fa-search fa-lg color-white cursor-pointer" onClick={() => showSearchDrawer()} aria-hidden="true"></i>

            <Drawer
                title={translate("products.productLabel.searchProducts")}
                placement="right"
                visible={isShowSearchDrawer}
                className="mobile-attr-filter"
                closeIcon={<i className="fa fa-times-circle fa-lg modal-close-button-icon" aria-hidden="true"></i>}
                closable={true}
                onClose={() => setIsShowSearchDrawer(false)}
                footer={null}
            >
                <div className="container">
                    <div className="row row--main">
                        <div className="w-100">
                            <Row justify="center" className="pl-3 pr-3">
                                <Col span={appSettings.isEnableBarCodeScanner ? 18 : 21} md={16}>
                                    <Search
                                        className="product-search-box-input mt-2 mb-2"
                                        placeholder={translate("common.header.search.placeholder")}
                                        onChange={(e) => onChange(e.target.value)}
                                        value={searchText}
                                        size="large"
                                        allowClear
                                        ref={inputRef}
                                    />
                                </Col>
                                <Col span={3} md={2} xl={1} className="text-center">
                                    <Button
                                        type="primary"
                                        shape="circle"
                                        onClick={showOrHideVoiceSearch}
                                        className="mt-12-px"
                                        icon={<i className="fa fa-microphone fa-lg cursor-pointer" aria-hidden="true"></i>}
                                    />
                                </Col>
                                {appSettings.isEnableBarCodeScanner &&
                                    <Col span={3} md={2} xl={1} className="text-center">
                                        <BarCodeSearchProducts setIsShowSearchDrawer={setIsShowSearchDrawer} />
                                    </Col>
                                }

                                <Divider />
                            </Row>

                            {/* Popular Search */}
                            {searchText.length < 3 ?
                                <Row justify="center">
                                    <Col span={24} md={16}>
                                        <div className="p-2">
                                            <Text strong>{translate("products.productLabel.searchByCategory")}</Text>
                                        </div>

                                        {(categoryMenu.isLoading || !categoryMenu.isFetchDataCompleted) ?
                                            <Spinner message={translate("home.CategoryHorizontalList.loading")} />
                                            :
                                            <React.Fragment>
                                                {categoryMenu.CAT.ids.length > 0 ?
                                                    <Row>
                                                        {categoryMenu.CAT.ids.map(categoryId => {
                                                            return (
                                                                <Col span={8} md={6} xl={4}
                                                                    key={categoryId}
                                                                    className="mt-2 p-1"
                                                                    onClick={() => onCatMenuClick(categoryId)}
                                                                >
                                                                    <Card className="border-radius-15 ant-card-with-box-shadow card-size-search-product" hoverable
                                                                        cover={
                                                                            <div className="img-card">
                                                                                <Img
                                                                                    className="p-1 fit-image h-100 border-radius-15"
                                                                                    alt="" src={[categoryMenu.CAT.data[categoryId].imageurl, placeholderImg]}
                                                                                    loader={<ImageLoader />}
                                                                                />
                                                                            </div>
                                                                        }>
                                                                        <Meta className="home-category-filter-text text-center" title={categoryMenu.CAT.data[categoryId].name} />
                                                                    </Card>
                                                                </Col>
                                                            )
                                                        })}
                                                    </Row>
                                                    :
                                                    <div className="no-category-found">
                                                        <NoData NoDataMessage={translate("home.CategoryHorizontalList.noData")} />
                                                    </div>
                                                }
                                            </React.Fragment>
                                        }

                                    </Col>
                                </Row>
                                :
                                <Row justify="center" className="pl-3 pr-3 search-list">
                                    <Col span={24} md={16}>
                                        {renderList()}
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
                </div>

                {/* Voice search modal */}
                {isShowVoiceSearchModal &&
                    <VoiceSearchModal
                        isShowVoiceSearchModal={isShowVoiceSearchModal}
                        cancelVoiceSearch={showOrHideVoiceSearch}
                        onSubmitVoiceCallBack={onSubmitVoiceCallBack}
                    />
                }
            </Drawer>
        </React.Fragment>
    );
};

export default SearchProducts;